import { Action } from '@ngrx/store';
import { EntriesState } from '../../../../core/features/store/base-feature-state';
import { DeliveryAddress, DeliveryAddressSearchResult } from '../../../../core/model/address.model';
import { SoldToActions } from '../actions';
import { DeliveryAddressActionTypes } from '../actions/sold-to-delivery-address.action';

export const initialState: EntriesState<DeliveryAddress> = {};

export function reducer(state = initialState, action: Action): EntriesState<DeliveryAddress> {
  switch (action.type) {
    case DeliveryAddressActionTypes.LoadDeliveryAddressesSuccess: {
      const addressesSuccess = <SoldToActions.LoadDeliveryAddressesSuccess>action;
      const payload: DeliveryAddressSearchResult = addressesSuccess.payload;

      const results = payload.results;

      return results.reduce(
        (entities: { [id: string]: DeliveryAddress }, entry: DeliveryAddress) => {
          return {
            ...entities,
            [entry.id]: entry,
          };
        },
        {
          ...state,
        }
      );
    }
    default:
      return state;
  }
}
